

jQuery(document).ready(function($) {
  
  // Function to set a cookie
  function setCookie(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
  }

  // Function to get a cookie
  function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Check if the body has the index class and if the splash screen has been shown today
  if ($('body').hasClass('index') && !getCookie("splashShown")) {
    // Show splash screen only on homepage
    $('#sm-splashscreen').fadeIn(500);
    $('body').addClass('sm-scroll-off'); // Add classes to prevent scrolling

    $('.sm-enter_link').click(function (e) {
      e.preventDefault();
      // Fade out the splash screen and remove classes
      $(this).parent('#sm-splashscreen').fadeOut(500, function() {
        $('body').removeClass('sm-scroll-off'); // Remove classes to allow scrolling
        console.log('sm-scroll-off removed'); // Debugging log
      });

      // Set a cookie to remember that the splash screen was shown
      setCookie("splashShown", "true", 1);
    });
  }
});



/*
jQuery(document).ready(function($) {
  // Function to set a cookie
  function setCookie(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
  }

  // Function to get a cookie
  function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Check if the splash screen has been shown today
  if (!getCookie("splashShown")) {
    // Show splash screen since cookie is not set
    $('#sm-splashscreen').fadeIn(500);
    $('body').addClass('sm-scroll-off'); // Add classes to prevent scrolling

    $('.sm-enter_link').click(function (e) {
      e.preventDefault();
      // Fade out the splash screen and remove classes
      $(this).parent('#sm-splashscreen').fadeOut(500, function() {
        $('body').removeClass('sm-scroll-off'); // Remove classes to allow scrolling
        console.log('Classes overflow-hidden and sm-scroll-off removed'); // Debugging log
      });

      // Set a cookie to remember that the splash screen was shown
      setCookie("splashShown", "true", 1);
    });
  }
});
*/


/*
jQuery(document).ready(function($) {
  // Function to set a cookie
  function setCookie(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
  }

  // Function to get a cookie
  function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Check if the splash screen has been shown today
  if (!getCookie("splashShown")) {
    // Show splash screen since cookie is not set
    $('#sm-splashscreen').fadeIn(500); // Smooth fade-in effect

    $('.sm-enter_link').click(function (e) {
      e.preventDefault();
      // Fade out the splash screen and remove the class
      $(this).parent('#sm-splashscreen').fadeOut(500, function() {
        $('body').removeClass('sm-scroll-off');
        console.log('Class sm-scroll-off removed'); // Debugging log
      });

      // Set a cookie to remember that the splash screen was shown
      setCookie("splashShown", "true", 1);
    });
  }
});
*/

/*
jQuery(document).ready(function($) {
  // Function to set a cookie
  function setCookie(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
  }

  // Function to get a cookie
  function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Check if the splash screen has been shown today
  if (!getCookie("splashShown")) {
    // Show splash screen since cookie is not set
    $('#sm-splashscreen').show();

    $('.sm-enter_link').click(function (e) {
      e.preventDefault();
      // Fade out the splash screen and remove the class
      $(this).parent('#sm-splashscreen').fadeOut(500, function() {
        $('body').removeClass('sm-scroll-off');
        console.log('Class sm-scroll-off removed'); // Debugging log
      });

      // Set a cookie to remember that the splash screen was shown
      setCookie("splashShown", "true", 1);
    });
  } else {
    // Hide splash screen if cookie is already set
    $('#sm-splashscreen').hide();
  }
});
*/
/*
jQuery(document).ready(function($) {
  $('.sm-enter_link').click(function () {
    // Ensure sm-splashscreen fades out first
    $(this).parent('#sm-splashscreen').fadeOut(500, function() {
      // After the fadeOut is complete, remove the class
      $('body').removeClass('sm-scroll-off');
      console.log('Class sm-scroll-off removed'); // Debugging log
    });
  });
});
*/

jQuery(document).on("click",".sm-accordion-item",function(){
    var trimmedText = $.trim(jQuery(this).text())
    console.log(trimmedText);
    
    if(trimmedText=="our story"){
       jQuery(".img-box img").removeAttr("style");  
        jQuery(".img-box img:eq(2)").show();
    }
    else if(trimmedText=="delivery & returns"){
        jQuery(".img-box img").removeAttr("style");
        jQuery(".img-box img:eq(3)").show();
    }
    else{
        jQuery(".img-box img").removeAttr("style");
        jQuery(".img-box img:eq(1)").show();
    }
});

jQuery(document).on("click","#checkout_direct_payment_fld_btns",function(){
  jQuery(".product-form form").submit();
});
jQuery(document).ready(function(){
  var currency_symb = '';
  var cartPopup ='';
  var cartItemsContainer ='';
  var currency_symb = '';
  var cartTotalElement ='';
  

  jQuery(document).on("click",".add_cart_btns_id",function(event){
    event.preventDefault();
    cartPopup = document.getElementById('cart-popup');
    cartItemsContainer = document.getElementById('cart-items');
    cartTotalElement = document.getElementsByClassName('totals__total-value')[0];
    
    const variantId = this.getAttribute('data-id');
    currency_symb = this.getAttribute('data-currency');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Display popup and refresh cart contents
      fetchCartData();
      cartPopup.style.display = 'block';
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);
      
      //alert('Sorry, there was an error adding this item to your cart.');
    });
  });
  function fetchCartData() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cartItemsContainer.innerHTML = ''; // Clear existing items

        cart.items.forEach((item, index) => {
          const itemRow = document.createElement('tr');
          itemRow.id = `CartDrawer-Item-${index + 1}`;
          itemRow.classList.add('cart-item');
          itemRow.setAttribute('role', 'row');

          itemRow.innerHTML = `
            <!-- Product Image -->
            <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">
              <a href="${item.url}" class="cart-item__link" tabindex="-1" aria-hidden="true">
                <img class="cart-item__image" src="${item.image}" alt="${item.title}" loading="lazy" width="150" height="150">
              </a>
            </td>

            <!-- Product Details -->
            <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">
              <a href="${item.url}" class="cart-item__name h4 break">${item.title}</a>
              <div class="product-option">${currency_symb}${(item.price / 100).toFixed(2)}</div>
            </td>

            <!-- Item Total Price -->
            <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">
              <div class="cart-item__price-wrapper">
                <span class="price price--end">${currency_symb}${(item.price / 100).toFixed(2)}</span>
              </div>
            </td>

            <!-- Quantity and Remove Button -->
            <td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">
              <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                <div class="quantity-popover-container">
                  <div class="quantity-input cart-quantity">
                    <!-- Decrease Quantity Button -->
                    <button class="quantity__button" name="minus" type="button" onclick="updateQuantity(${item.id}, ${item.quantity - 1})">
                      <span class="visually-hidden">Decrease quantity for ${item.title}</span>
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2">
                          <path fill="currentColor" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1"/>
                        </svg>
                      </span>
                    </button>
                    <!-- Quantity Input -->
                    <input class="quantity__input" type="number" data-quantity-variant-id="${item.id}" value="${item.quantity}" min="1" step="1" aria-label="Quantity for ${item.title}">
                    <!-- Increase Quantity Button -->
                    <button class="quantity__button" name="plus" type="button" onclick="updateQuantity(${item.id}, ${item.quantity + 1})">
                      <span class="visually-hidden">Increase quantity for ${item.title}</span>
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10">
                          <path fill="currentColor" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z"/>
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
                <!-- Remove Button -->
                <button type="button" class="button button--tertiary cart-remove-button removed_item_id" aria-label="Remove${item.title}" data-id="${item.id}">
                  Remove
                </button>
              </div>
            </td>
          `;

          cartItemsContainer.appendChild(itemRow);
          
        });
        updateCartTotal(cart.total_price);
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }
  jQuery(document).on("click",".removed_item_id",function(event){
    event.preventDefault();
    var remove_id_items = jQuery(this).attr("data-id");
    updateQuantity(remove_id_items, 0);
  });
  function updateCartTotal(totalPrice) {
  const formattedTotal = `${currency_symb}${(totalPrice / 100).toFixed(2)}`; // Adjust based on dynamic currency
  cartTotalElement.innerText = formattedTotal;
}
  
  function updateQuantity(variantId, newQuantity) {
  fetch(`/cart/change.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id: variantId, quantity: newQuantity })
  })
  .then(response => fetchCartData())
  .catch(error => console.error('Error updating quantity:', error));
}

//jQuery(".product__description.rte.quick-add-hidden").("ul#sm-what-in-the-boc");


});



